const Share = () => {
  return (
    <div>
      <p className="text-center text-green-600 font-medium flex justify-center p-4 border-2 border-green-600 rounded-md">
        Félicitations! Votre carte est activée! Passez nous voir prochainement.
        Plus vous nous visitez, plus votre rabais résident augmentera. À
        bientôt!
      </p>
    </div>
  );
};

export default Share;
